import {IamFoundationActionsTypes, IamFoundationActions} from '../actions/iamFoundation-actions.constant';

export interface IIamFoundationState {
  iamFoundationEnabled: any;
}

const InitIamFoundationState: IIamFoundationState = {
  iamFoundationEnabled: false
}

export function iamFoundationReducer(state: IIamFoundationState = InitIamFoundationState, action: IamFoundationActions): IIamFoundationState {
  switch (action.type) {
    case IamFoundationActionsTypes.UPDATE_IAM_FOUNDATION_STATUS:
      return {...state, iamFoundationEnabled: action.payload.status};
    default:
      return state;
  }
}
